export const MINITO_H5_MAP = {
  "__投放作品.小程序路径__": "__投放作品.推广链接__",
  "__其它作品1.小程序路径__": "__其它作品1.推广链接__",
  "__其它作品2.小程序路径__": "__其它作品2.推广链接__",
  "__其它作品3.小程序路径__": "__其它作品3.推广链接__",
  "__其它作品4.小程序路径__": "__其它作品4.推广链接__",
  "__其它作品5.小程序路径__": "__其它作品5.推广链接__",
  "__其它作品6.小程序路径__": "__其它作品6.推广链接__",
  "__其它作品7.小程序路径__": "__其它作品7.推广链接__",
  "__其它作品8.小程序路径__": "__其它作品8.推广链接__",
  "__签到活动.小程序路径__": "__签到活动.活动链接__",
  "__充值优惠活动1.小程序路径__": "__充值优惠活动1.活动链接__",
  "__充值优惠活动2.小程序路径__": "__充值优惠活动2.活动链接__",
  "__充值优惠活动3.小程序路径__": "__充值优惠活动3.活动链接__",
  "__充值优惠活动4.小程序路径__": "__充值优惠活动4.活动链接__",
  "__充值优惠活动5.小程序路径__": "__充值优惠活动5.活动链接__",
  "__充值优惠活动6.小程序路径__": "__充值优惠活动6.活动链接__",
  "__充值优惠活动7.小程序路径__": "__充值优惠活动7.活动链接__",
  "__充值优惠活动8.小程序路径__": "__充值优惠活动8.活动链接__",
  "__继续阅读.小程序路径__": "__继续阅读.链接__",
  "__阅读记录.小程序路径__": "__阅读记录.链接__",
  "__阅读记录2.小程序路径__": "__阅读记录2.链接__",
  "__阅读记录3.小程序路径__": "__阅读记录3.链接__",
  "__书城首页.小程序路径__": "__书城首页.链接__",
  "__排行榜.小程序路径__": "__排行榜.链接__",
  "__个人中心.小程序路径__": "__个人中心.链接__",
  "__个人中心2.小程序路径__": "__个人中心2.链接__",
  "__个人中心3.小程序路径__": "__个人中心3.链接__",
  "__联系客服.小程序路径__": "__联系客服.链接__",
  "__引导置顶.小程序路径__": "__引导置顶.链接__",
};
// 本地标签类型，1=系统生成，2=微信自有星标组，3=运营创建
export const GZH_LABEL_TYPE_LIST = [
  {
    label: "系统生成",
    value: 1,
  },
  {
    label: "微信自有星标组",
    value: 2,
  },
  {
    label: "运营创建",
    value: 3,
  },
];
export const GZH_LABEL_TYPE_MAP = {
  1: `系统生成`,
  2: `微信自有星标组`,
  3: `运营创建`,
};
